import HTTP from '../common/http-common';

const END_POINT = '/withdraw';

const listWithdraw = (withdrawNo,dateFrom,dateTo,branchCode) => HTTP.get(END_POINT+"?withdrawNo="+withdrawNo+
"&dateFrom=" + dateFrom + "&dateTo=" + dateTo+"&branchCode="+branchCode);

const listCloseJob = (closeJobNo,dateFrom,dateTo,branchCode) => HTTP.get(END_POINT+"/closeJob?closeJobNo="+closeJobNo+
"&dateFrom=" + dateFrom + "&dateTo=" + dateTo+"&branchCode="+branchCode);

const listInvoice = (dateFrom,dateTo,branchCode) => HTTP.get(END_POINT+ "/invoice?dateFrom=" 
+ dateFrom + "&dateTo=" + dateTo+"&branchCode="+branchCode);

const listItemByWithdrawNo = (withdrawNo) => HTTP.get(END_POINT +"/invoice-withdraw/"+  withdrawNo ); //,{ cache: false }
const listItemByCloseJobNo = (closJobNo, branchCode) => HTTP.get(END_POINT +"/invoice-close-job/"+  closJobNo +"?branchCode=" + branchCode );

const insertWithdraw = (data) => HTTP.post(END_POINT,{
    rankDate: data.rankDate ,
    trnCount: data.trnCount ,
    trnTotal: data.trnTotal ,
    trnGrandTotal: data.trnGrandTotal ,
    branchCode: data.branchCode ,
    listItem : data.listData 
});
const removeItemWithdraw = (data) => HTTP.post(END_POINT + "/removeItemWithdraw", {
    withdrawNo: data.withdrawNo ,
    trnCount: data.trnCount ,
    trnTotal: data.trnTotal ,
    trnGrandTotal: data.trnGrandTotal ,
    listItem: data.listData
});

const closeJob = (data) => HTTP.post(END_POINT + "/closeJob", {
    withdrawNo: data.withdrawNo,
    rankDate: data.rankDate ,
    trnCount: data.trnCount ,
    trnTotal: data.trnTotal ,
    trnGrandTotal: data.trnGrandTotal ,
    cheqNo: data.cheqNo,
    branchCode: data.branchCode ,
    listItem : data.listData 
});


export {
    listWithdraw,
    listCloseJob,
    listInvoice,
   // listWithdrawByWithdrawNo,
   listItemByWithdrawNo,
   listItemByCloseJobNo,
    insertWithdraw,
    removeItemWithdraw,
    closeJob
}